import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

//Показывается ли портфель пользователя в рейтинге комьюнити
export async function getPortfolioVisibility() {
  const response = await fetchWithAuth(`${backendUrl}/api/portfolios/visibility/`, { method: 'GET' });
  if (!response.ok) {
    throw new Error(`Не удалось получить настройку публичности: HTTP ${response.status}`);
  }
  return response.json();
}
